import { motion } from "framer-motion"
import { Rocket, Clock, ArrowLeft, Construction } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Badge } from "@/components/ui/badge"
import { Icon } from "@/components/Atoms/Icon"
import { useNavigate } from "react-router-dom"

export const OverdeliveryPage = () => {
  const navigate = useNavigate()

  return (
    <div className="relative flex min-h-[85vh] w-full flex-col items-center justify-center overflow-hidden rounded-xl border border-border/40 bg-background/50">
      {/* Background Decorativo - Círculos com Blur */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute -left-[10%] -top-[10%] h-[40%] w-[40%] rounded-full bg-primary/5 blur-[120px]" />
        <div className="absolute -bottom-[10%] -right-[10%] h-[40%] w-[40%] rounded-full bg-primary/10 blur-[120px]" />
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="z-10 flex max-w-[500px] flex-col items-center p-6 text-center"
      >
        {/* Badge de Status */}
        <motion.div
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <Badge
            variant="secondary"
            className="mb-6 bg-orange-500/20 px-4 py-1 text-sm font-medium uppercase tracking-wider text-orange-500"
          >
            <Clock className="mr-2 h-3 w-3" />
            Lançamento em Breve
          </Badge>
        </motion.div>

        {/* Ícone Central Animado */}
        <motion.div
          animate={{
            y: [0, -20, 0],
            rotate: [0, 5, -5, 0],
          }}
          transition={{
            duration: 5,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="relative mb-8 flex h-28 w-28 items-center justify-center rounded-3xl bg-gradient-to-br from-primary/20 to-primary/5 shadow-inner"
        >
          <div className="text-orange-500">
            <Icon
              size={56}
              state="elegant"
              name="rocket-lunch"
            />
          </div>

          {/* Pequeno detalhe de faísca/brilho */}
          <motion.div
            animate={{ opacity: [0, 1, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
            className="absolute right-0 top-0 h-4 w-4 rounded-full bg-primary blur-sm"
          />
        </motion.div>

        {/* Título e Texto */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <h1 className="mb-4 text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
            Módulo <span className="text-primary">Overdelivery</span>
          </h1>
          <p className="mb-8 text-lg leading-relaxed text-muted-foreground">
            Estamos preparando uma experiência ainda mais completa para você!
          </p>
        </motion.div>

        {/* Barra de Progresso Simbólica */}
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: "100%" }}
          transition={{ delay: 0.5, duration: 1 }}
          className="mb-8 w-full max-w-[300px]"
        >
          <div className="mb-2 flex justify-between text-xs text-muted-foreground">
            <span>Desenvolvimento</span>
            <span>85%</span>
          </div>
          <div className="h-2 w-full overflow-hidden rounded-full bg-secondary">
            <motion.div
              initial={{ x: "-100%" }}
              animate={{ x: "-15%" }}
              transition={{ delay: 1, duration: 1.5, ease: "easeOut" }}
              className="h-full w-full bg-primary"
            />
          </div>
        </motion.div>

        {/* Ação de Retorno */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7 }}
        >
          <Button
            onClick={() => navigate("/dashboard")}
            variant="ghost"
            className="text-muted-foreground hover:text-foreground"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Voltar para o Dashboard
          </Button>
        </motion.div>
      </motion.div>

      {/* Ícones flutuantes decorativos ao redor */}
      <Construction className="absolute left-[15%] top-20 hidden h-8 w-8 rotate-12 text-muted-foreground/20 md:block" />
      <div className="absolute bottom-20 right-[15%] hidden h-12 w-12 rounded-full border-2 border-primary/10 md:block" />
    </div>
  )
}
